<template>
  <v-card
      class="pb-5 mx-auto mb-2"
      max-width="500"
  >
    <v-img
        v-if="image && mediaFormat === 'PHOTO'"
        class="white--text align-end"
        :src="image"
    />
    <iframe
        v-if="image && mediaFormat === 'VIDEO'"
        loading="lazy"
        sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation"
        class="embed-responsive-item"
        allowfullscreen
        :src="image"
        height="250px"
        width="100%"
        frameborder="0">
    </iframe>

    <v-card-subtitle class="d-flex" v-if="!image || type === postsConstants.ALERT_TYPE">
      <div class="text-left" v-if="!image">{{ createdAt }}</div>
      <v-spacer />
      <div class="text-right" v-if="type === postsConstants.ALERT_TYPE">
        <v-icon small class="mr-1 pt-0 pb-1" color="error">mdi-alert-outline</v-icon>
        <span class="font-weight-medium subtitle-2">Atualização da COVID-19</span>
      </div>
    </v-card-subtitle>

    <v-card-title v-if="title">
      {{ title }}
    </v-card-title>

    <v-card-subtitle v-if="eventSchedule">
      {{ eventSchedule }}
    </v-card-subtitle>

    <v-card-text class="py-0" v-if="offerRedeemOnlineUrl">
      <v-btn outlined small color="primary" @click="openLink(offerRedeemOnlineUrl)">Resgatar on-line</v-btn>
    </v-card-text>

    <v-card-text v-if="offerCouponCode || eventScheduleCode">
      <v-card outlined class="dashed-border" color="grey lighten-4">
        <v-card-subtitle>
          <p
            v-if="offerCouponCode"
            style="text-align: center"
            class="my-0 py-0 text--black caption"
          >
            Mostre este código na loja
          </p>
          <p
            v-if="offerCouponCode"
            style="text-align: center; color: black"
            class="my-3 py-0 text-h5 font-weight-bold"
          >
            {{ offerCouponCode }}
          </p>
          <p
            v-if="eventScheduleCode"
            style="text-align: center"
            class="my-0 py-0 text--black caption"
          >
            Validade: {{ eventScheduleCode }}
          </p>
        </v-card-subtitle>
      </v-card>
    </v-card-text>

    <v-card-text class="py-0" v-if="offerTermsAndConditions">
      <v-btn
          x-small
          text
          color="primary"
          @click="openTerms = !openTerms"
      >
        Termos e Condições
        <v-icon>{{ openTerms ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
      <v-expand-transition>
        <div v-show="openTerms" class="pl-2">
          {{ offerTermsAndConditions }}
        </div>
      </v-expand-transition>
    </v-card-text>

    <v-card-text class="text--primary" v-if="summary">
      {{ summary }}
    </v-card-text>

    <v-card-text class="py-0" v-if="actionButtonLink && actionButtonType">
      <v-btn
          outlined
          color="primary"
          @click="openLink(actionButtonLink)"
      >
        {{ getButtonName(actionButtonType) }}
      </v-btn>
    </v-card-text>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import * as postsConstants from '@/constants/posts'

export default {
  name: 'LocationPostPreview',
  props: {
    id: Number,
    title: String,
    image: String,
    mediaFormat: String,
    summary: String,
    type: String,
    actionButtonType: String,
    actionButtonLink: String,
    createdAt: String,
    alertType: String,
    eventSchedule: String,
    eventScheduleCode: String,
    offerRedeemOnlineUrl: String,
    offerCouponCode: String,
    offerTermsAndConditions: String,
    locationName: String,
    locationPhone: String,
    onUpdated: Function,
    noAction: Boolean,
    openDate: String,
    openTime: String,
    closeDate: String,
    closeTime: String,
  },
  computed: {
    postsConstants: function() {
      return postsConstants
    }
  },
  data: () => ({
    openTerms: false,
    loadingDelete: false,
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
  }),
  methods: {
    openLink: function(url) {
      window.open(url)
    },
    getButtonName: function(type) {
      switch (type) {
        case postsConstants.ACTION_TYPE_BOOK:
          return 'Reservar'
        case postsConstants.ACTION_TYPE_ORDER:
          return 'Fazer o pedido'
        case postsConstants.ACTION_TYPE_SHOP:
          return 'Comprar'
        case postsConstants.ACTION_TYPE_LEARN_MORE:
          return 'Saiba mais'
        case postsConstants.ACTION_TYPE_SIGN_UP:
          return 'Inscreva-se'
        case postsConstants.ACTION_TYPE_CALL:
          return 'Ligar agora'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
.dashed-border {
  border: none;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23E0E0E0FF' stroke-width='4' stroke-dasharray='3%2c 9' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 12px;
}
</style>